import React from 'react';
import { StaticQuery } from 'gatsby';
import { findT } from '../../_helpers';
import { FormattedMessage } from 'react-intl';
import { jsx as ___EmotionJSX } from "@emotion/react";
const AddressWidget = props => {
  let showLogo;
  const defaultProps = {
    showLogo: false
  };
  const translations = findT(props.widget.translations, props.lang);
  if (!props.widget.props) {
    showLogo = defaultProps.showLogo;
  } else {
    showLogo = props.widget.props.showLogo;
  }
  return ___EmotionJSX(StaticQuery, {
    query: query,
    render: data => {
      const address = data.directusCompany.addresses[0];
      const name = data.directusCompany.display_name;
      return ___EmotionJSX(React.Fragment, null, showLogo && ___EmotionJSX("img", {
        style: {
          maxWidth: '100%',
          maxHeight: '80px',
          margin: '0'
        },
        src: data.directusProject.logo.localFile.publicURL,
        alt: name,
        title: name
      }), !showLogo && ___EmotionJSX("h4", null, translations.header ? translations.header : ___EmotionJSX(FormattedMessage, {
        id: "components.widgets.addressWidget.defaultHeader"
      })), ___EmotionJSX("address", null, ___EmotionJSX("ul", null, ___EmotionJSX("li", null, name), ___EmotionJSX("li", null, address.street, " ", address.number), ___EmotionJSX("li", null, address.zip_code, " ", address.city))));
    }
  });
};
const query = "2975241290";
export default AddressWidget;